import { Box } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import FeatureCompareTable from 'modules/billing/components/FeatureCompareTable'
import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'

type Props = {
  onClose: () => void
  isOpen: boolean
}

const FeaturesComparisonSidepanel = ({ onClose, isOpen }: Props) => {
  const { allPlans } = usePricingContext()

  return (
    <Sidepanel
      title={i18n.t('pricing_plans.comparison_table.title')}
      closeLabel="Close"
      open={isOpen}
      onClose={onClose}
      width="extended"
    >
      <Box alignSelf="center" paddingY="s48" style={{ width: '900px' }}>
        <Box gap="s16">
          {allPlans.comparisonPlans.map((plan, index) => (
            <FeatureCompareTable plan={plan} key={plan.title} index={index} />
          ))}
        </Box>
      </Box>
    </Sidepanel>
  )
}

export default FeaturesComparisonSidepanel
